/* eslint-disable */
import React, { ReactNode } from 'react';
import { FormattingOptionItem } from '../../../concepts/text/FormattingOptionItem';
import { Shape } from '../../packages/shapes/Shape';
import { ShapeData } from '../../packages/shapes/ShapeAlgorithm';
import { RenderBounds, RenderGraffiti, RenderInner, usePose } from './RenderHelpers';
import { RenderText } from './RenderText';

const RenderShape = React.memo<{ data: ShapeData }>(({ data }) => {
    const { bounds, paths } = data;
    const styling = {
        position: 'absolute' as const,
        left: bounds.left,
        top: bounds.top,
    }
    return <svg style={styling} width={bounds.width} height={bounds.height}>
        <g transform={`translate(${bounds.left * -1}, ${bounds.top * -1})`}>
            {paths.map(({ d, ...props }, i) => <path key={i} d={d.toString()} {...props} />)}
        </g>
    </svg>
});

export const ShapeVisual = ({ object, children }: { object: Shape, children: ReactNode }) => {

    const { layout } = object;
    const { beingEdited } = usePose(object);

    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderShape data={layout.data} />
                <RenderGraffiti object={object} />
                {!beingEdited &&
                    <RenderText
                        bounds={layout.content2.bounds}
                        settings={layout.content2.settings}
                        value={object.content}
                        formatOpts={FormattingOptionItem.defaults}
                    />
                }
            </RenderInner>
        </RenderBounds>
        {children}
    </>;
};

// export class ShapeVisualOld extends VisualBase<Shape> {

//     @aspect()
//     private get svgData() {
//         const alg = ShapeAlgorithm.for(this.object.kind);
//         const cfg = Object.assign(
//             Obj.pick(this.object, 'cornerRadius', 'sides', 'stroke', 'style', 'width', 'height', 'tail'),
//             { color: this.object.background },
//         );
//         const data = alg(cfg);
//         const svg = `<svg width="${this.object.width}" height="${this.object.height}" xmlns="http://www.w3.org/2000/svg">
//             ${data.paths.map((props) => `<path ${Object.entries(props).map(([k, v]) => `${paramCase(k)}="${v.toString()}"`).join(' ')} />`).join('\n')}
//         </svg>`;
//         return `url('data:image/svg+xml;utf-8,${encodeURIComponent(svg)}')`;
//     }

//     private get borderStyling(): any {
//         const { object } = this.props;
//         return {
//             width: object.width,
//             height: object.height,
//             // background: this.svgData,
//         };
//     }

//     private get emoticonStyling(): any {
//         return {
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             color: this.object.getPreferredTextColor(),
//             width: Math.min(this.object.width, this.object.height),
//             height: Math.min(this.object.width, this.object.height),
//             transform: 'translate(-50%, -50%) scale(.8)',
//         };
//     }

//     @aspect()
//     private get emoticon(): string {
//         const icon = Emoticon.lookup(this.object.content.value);
//         return !!icon ? `deqo://icons/tokens/${icon}` : null;
//     }

//     public render() {
//         return <>
//             <RenderBounds object={this.object}>
//                 <RenderBorder pose={this.pose} style={this.borderStyling}>
//                     <RenderShape object={this.object} />
//                     <RenderGraffiti object={this.object} />
//                     {!this.isBeingEdited && !this.emoticon && <RenderTextField object={this.object} name="content" />}
//                     {!this.isBeingEdited && this.emoticon && <Icon src={this.emoticon} style={this.emoticonStyling} />}
//                 </RenderBorder>
//             </RenderBounds>
//             {this.props.children}
//         </>;
//     }
// }